import axios from "axios";
import { AxiosMULEEX, $API_GATEWAY_UPLOAD } from "./apiConfig";

const $simpleAuthHeader = {
  Accept: "application/json",
  'Access-Control-Allow-Origin': '*'
};


// const url = "https://api.cloudinary.com/v1_1/thevetdoctor";  
// const url = process.env.VUE_APP_DOCUMENT_UPLOAD
// console.log($API_GATEWAY_UPLOAD)


const AxiosMULEEX__ = axios.create({
  baseURL: $API_GATEWAY_UPLOAD,
  headers: $simpleAuthHeader,
});

export const imageUploadFactory = {
  $_uploadImage(payload) {
    const url = "/document-management/upload/muleex";
    return AxiosMULEEX__.post(url, payload);
  },
  $_uploadDocs(payload) {
    const url = "/document-management/upload/muleex";
    return AxiosMULEEX__.post(url, payload);
  },
  $_updateProfileImage(payload) {
    const url = "users/profile-image";
    return AxiosMULEEX.post(url, payload);
  },
};
